export default {
  DELIVERED: 'DELIVERED',
  IN_TRANSIT: 'IN_TRANSIT',
  PRE_TRANSIT: 'PRE_TRANSIT',
  NONE: 'NONE'
};
